import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import {
  VaLinkAction,
  VaLink,
} from '@department-of-veterans-affairs/component-library/dist/react-bindings';

/** @typedef {'default' | 'action' | 'action.secondary'} Variant */
/**
 * @typedef {object} AskVaLinkProps
 * @property {string} href Use _without_ starting `/` to append to Ask VA's base URL
 * @property {string} text
 * @property {Variant} [variant]
 * @property {React.MouseEventHandler<HTMLVaLinkActionElement>} [onClick]
 * @property {{push: (path: string) => void}} router
 */

/** @param {AskVaLinkProps} props */
function AskVaLink({ href, text, variant = 'default', router, onClick }) {
  const handleClick = e => {
    e.preventDefault();
    if (onClick) {
      onClick(e);
    } else {
      router.push(href);
    }
  };

  switch (variant) {
    case 'action':
      return (
        <VaLinkAction
          onClick={handleClick}
          type="primary"
          {...{ href, text }}
        />
      );

    case 'action.secondary':
      return (
        <VaLinkAction
          onClick={handleClick}
          type="secondary"
          {...{ href, text }}
        />
      );

    default:
      return <VaLink {...{ href, text }} onClick={handleClick} />;
  }
}

AskVaLink.propTypes = {
  href: PropTypes.string.isRequired,
  router: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  text: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['default', 'action', 'action.secondary']),
  onClick: PropTypes.func,
};

/** @type {(props: Omit<AskVaLinkProps, 'router'>) => JSX.Element} */
const AskVaLinkWithRouter = withRouter(AskVaLink);

export default AskVaLinkWithRouter;
